import BaseComponent from "../../../baseComponent.js";
import Expression from "./expression.jsx";
import Label from "./label.jsx";
import Color from "./color.jsx";
import Actions from "./actions.jsx";
import styles from "./styles.scss";
import CustomColor from "./customColor.jsx";

export default class TreeMapConfig extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div className={styles.legendConfig} name="legendConfig">
        <div className={styles.legendConfigContent}>
          <Actions closeLegendConfig={this.props.closeLegendConfig} copyLegend={this.props.copyLegend}/>
          <Label label={this.props.legend.parameters.legendLabel}
                 onLegendChange={this.props.onLegendChange}/>
          <Expression label="Data"
                      expressionKey="y"
                      widgetId={this.props.widgetId}
                      legendId={this.props.legend.id}
                      onLegendChange={this.props.onLegendChange}
                      expression={this.props.legend.expressions.y}
                      mappings={this.props.legend.mappings}/>
          <Color color={this.props.legend.parameters.legendColor}
                 onLegendChange={this.props.onLegendChange}/>
          <CustomColor color={this.props.legend.parameters.legendColor}
                       onLegendChange={this.props.onLegendChange}/>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/treeMapConfig.jsx